// https://github.com/cmp-cc/vue-cookies
import Vue from 'vue'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
